import React from "react";
var __jsx = React.createElement;
import { useCallback, useEffect, useState } from 'react';
import { ImageDialog } from 'components/common/ImageDialog';
import useGetBlockData from 'components/common/RichTextEditor/hooks/useGetBlockData';

var Image = function Image(_ref) {
  var editorState = _ref.editorState,
      blockKey = _ref.blockKey,
      entityKey = _ref.entityKey,
      removeBlock = _ref.removeBlock,
      updateBlockData = _ref.updateBlockData,
      updateEntity = _ref.updateEntity;

  var _useState = useState(),
      imageData = _useState[0],
      setImageData = _useState[1];

  var _useState2 = useState(false),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useGetBlockData = useGetBlockData(editorState, blockKey, entityKey),
      blockData = _useGetBlockData.blockData,
      entityData = _useGetBlockData.entityData;

  useEffect(function () {
    setIsOpen(blockData.openModal);
    setImageData(entityData);
  }, [blockData, entityData]);
  var handleModalClose = useCallback(function () {
    if ((imageData === null || imageData === void 0 ? void 0 : imageData.imgUrl) === undefined) {
      removeBlock(blockKey);
      return;
    }

    updateBlockData(blockKey, {
      openModal: false
    });
  }, [imageData, updateBlockData, blockKey, removeBlock]);
  var handleConfirm = useCallback( // Todo: here whe should use ImageEntityData type instead of ImageData
  function (imageDataConfirm) {
    updateEntity(entityKey, imageDataConfirm);
    updateBlockData(blockKey, {
      openModal: false
    });
  }, [blockKey, entityKey, updateBlockData, updateEntity]);
  return __jsx(ImageDialog, {
    open: isOpen // Todo: remove this use of "as"
    ,
    initialData: imageData,
    onClose: handleModalClose,
    onConfirm: handleConfirm
  });
};

export default Image;